const sensor = {
    id: 0,
    label: null,
    type: null,
    activated: false,
    alarm: false,
    battery: null,
    firmware: null,
    iccid: null,
    imei: null,
    last_connected: null,
    measurement: null,
    owner: 0,
    pin: null,
    serial: null,
    signal: null,
    subscription_end: null,

    settings: {}
};

export const fromAPIData = function (raw) {

    let sensor = {};
    for (const [key, value] of Object.entries(raw)) {
        sensor[key] = value
    }

    return sensor
};

export default sensor



// WEBPACK FOOTER //
// ./src/sensor.js